import { ErrorHandler, NgModule } from '@angular/core';

import { APP_BASE_HREF } from '@angular/common';
import { AmCommonModule } from 'app/core/am-common.module';
import { AppComponent } from './app.component';
import { AppRoutingModule } from 'app/core/app-routing.module';
import { ApplicationInsightsErrorHandler } from './services/error-handler-service/error-handler.service';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule } from '@angular/forms';
import { environment } from 'environments/environment';
import { MAT_FORM_FIELD_DEFAULT_OPTIONS, MatFormFieldDefaultOptions } from '@angular/material/form-field';
import { MatDialogModule } from '@angular/material/dialog';

const env = environment;

@NgModule({
  declarations: [AppComponent],
  exports: [],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    FormsModule,
    AmCommonModule,
    AppRoutingModule,
    MatDialogModule
  ],
  providers: [
    { provide: ErrorHandler, useClass: ApplicationInsightsErrorHandler },
    { provide: APP_BASE_HREF, useValue: env.baseHref },
    {
      provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
      useValue: { appearance: 'outline', floatLabel: 'always' } as MatFormFieldDefaultOptions
    }
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
